'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
import { ModalConfirmComponent } from '../../../components/common/hd-modal/confirm';
import Popup from '../../../components/common/hd-modal/popup';
import ModalController from './modal-confirm-controller';
const ModalContext = createContext(undefined);
export const ModalProvider = ({ children }) => {
    const controller = ModalController.getInstance();
    const [modals, setModals] = useState({});
    const isModalOpen = (id) => id in modals;
    const deleteModal = (id) => {
        setModals((prev) => {
            const _a = prev, _b = id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return rest;
        });
    };
    const upsertModal = (options) => {
        var _a;
        const id = (_a = options.id) !== null && _a !== void 0 ? _a : crypto.randomUUID();
        setModals((prev) => (Object.assign(Object.assign({}, prev), { [id]: { type: 'default', props: options } })));
    };
    const confirm = (options) => {
        const id = crypto.randomUUID();
        return new Promise((resolve) => {
            setModals((prev) => (Object.assign(Object.assign({}, prev), { [id]: {
                    type: 'confirm',
                    props: options,
                    resolver: resolve,
                } })));
        });
    };
    const handleClose = (id, state) => {
        setModals((prev) => {
            var _a, _b, _c, _d, _e;
            const _f = prev, _g = id, modal = _f[_g], rest = __rest(_f, [typeof _g === "symbol" ? _g : _g + ""]);
            if (!modal)
                return prev;
            if (modal.type === 'confirm') {
                const props = modal.props;
                state === 'confirm' ? (_a = modal.resolver) === null || _a === void 0 ? void 0 : _a.call(modal, true) : (_b = modal.resolver) === null || _b === void 0 ? void 0 : _b.call(modal, false);
                state === 'confirm' ? (_c = props.onOk) === null || _c === void 0 ? void 0 : _c.call(props) : (_d = props.onCancel) === null || _d === void 0 ? void 0 : _d.call(props);
            }
            else {
                const props = modal.props;
                (_e = props.handleCancel) === null || _e === void 0 ? void 0 : _e.call(props);
            }
            return rest;
        });
    };
    useEffect(() => {
        controller.setConfirmFn(confirm);
    }, []);
    return (_jsxs(ModalContext.Provider, { value: { confirm, upsertModal, handleClose, isModalOpen, deleteModal }, children: [children, Object.entries(modals).map(([id, { type, props }]) => {
                const ModalComponent = type === 'confirm' ? ModalConfirmComponent : Popup;
                return (_jsx(ModalComponent, Object.assign({}, props, { handleCancel: () => handleClose(id), onOk: () => handleClose(id, 'confirm'), onCancel: () => handleClose(id, 'cancel'), onClose: () => handleClose(id) }), id));
            })] }));
};
export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
